import { graphql } from "@repo/graphql-types/gql";
import { createFileRoute, useRouter, useSearch } from "@tanstack/react-router";
import { HelpCircle, Left } from "@repo/icons";
import {
  AppointmentChanel,
  AppointmentTypeCategoryEnum,
  formatWithZonedDate,
} from "@repo/lib";
import { useGraphQL } from "@/hooks/use-graphql";
import { AsyncDataWrapper } from "@/components/async-data-wrapper";
import { HeaderButton, HeaderRoot, HeaderTitle } from "@/components/header";
import { Page } from "@/components/page";
import { FollowUpAppointmentReminderForm } from "@/components/follow-up-appointment-reminder-form";
import { FollowUpAppointmentReminderMessageDrawer } from "@/components/follow-up-appointment-reminder/follow-up-appointment-reminder-message-drawer";

const FollowUpAppointmentReminderPageCreateQuery = graphql(/* GraphQL */ `
  query FollowUpAppointmentReminderPageCreateQuery(
    $codAgendamento: Int!
    $canalAgendamentoPaciente: Int!
    $categoriaPeriodoGarantido: Int!
    $dataInicio: date!
  ) {
    ...FollowUpAppointmentReminderFormFragment
    appointment: agendamentos_by_pk(codAgendamento: $codAgendamento) {
      ...FollowUpAppointmentReminderMessageDrawerFragment
      nome
      Usuario {
        apelido
        nome
        sobrenome
      }
      UsuarioCompromisso {
        nome
      }
    }
  }
`);

export const FollowUpAppointmentReminderCreatePage = (): JSX.Element => {
  const { appointmentId } = Route.useParams();
  const searchParams: Record<string, unknown> = useSearch({ strict: false });
  const router = useRouter();

  const queryResult = useGraphQL(FollowUpAppointmentReminderPageCreateQuery, {
    codAgendamento: Number(appointmentId),
    canalAgendamentoPaciente: AppointmentChanel.Paciente.valueOf(),
    categoriaPeriodoGarantido: AppointmentTypeCategoryEnum.PeriodoGarantido.valueOf(),
    dataInicio: formatWithZonedDate(new Date(), "yyyy-MM-dd"),
  });

  const { data } = queryResult;

  const openAboutDrawer = (): void => {
    void router.navigate({
      search: {
        ...searchParams,
        action: "about",
      },
    });
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Lembrete de retorno" align="center" />
        <HeaderButton icon={HelpCircle} align="end" onClick={openAboutDrawer} />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? <FollowUpAppointmentReminderForm data={data} /> : null}

          {data?.appointment ? (
            <FollowUpAppointmentReminderMessageDrawer data={data.appointment} />
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute(
  "/waiting-room/follow-up-appointment-reminder/$appointmentId",
)({
  component: FollowUpAppointmentReminderCreatePage,
});
